import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { RelaysState } from './types';
import { Client, SetRelayRequest } from '@/common/apis/DeviceApi';
import ApiProvider from '@/common/apis/ApiProvider';

const relayPromise: {[deviceNumber: string]: Promise<any> } = {};
let hold: boolean = false;
let holdTimeout: number;
let latestRequestDate: Date = new Date();

export const actions: ActionTree<RelaysState, RootState> = {


    async load(
        { commit, rootState },
        args: { deviceNumber: string, forceUpdate?: boolean}): Promise<any> {

        if (!args.forceUpdate && relayPromise[args.deviceNumber]) {
            return relayPromise[args.deviceNumber];
        }
        return relayPromise[args.deviceNumber] = new Promise(async (resolve, reject) => {
            // if (Math.random() > 0.1) {
            //     console.error('Random error');
            //     reject('Random error');
            // }
            try {
                const api = ApiProvider.getDeviceApi();
                const relayResponse = await api.getRelays(args.deviceNumber);
                const relays = relayResponse.relays || [];
                commit('loaded', { deviceNumber: args.deviceNumber, relays });
                resolve();
            } catch (e) {
                reject(e);
            }
            delete relayPromise[args.deviceNumber];
        });
    },
    async toggle(
        { commit, state, rootState },
        args: { deviceNumber: string, relayNumber: number}) {

        commit('toggleRelay', args);
        commit('setLoading', args);
        const relay = state.relays[args.deviceNumber][args.relayNumber];
        try {
            const api = ApiProvider.getDeviceApi();
            const date = new Date();
            latestRequestDate = date;
            const relayResponse = await api.setRelay(new SetRelayRequest({
                deviceId: args.deviceNumber,
                relayNumber: args.relayNumber,
                turnOn: relay.isOn,
                turnOfAfterMs: undefined,
            }));

            // this means, that this was the latest request, thus we can update the sate
            if (date === latestRequestDate) {
                const relays = relayResponse.relays || [];
                commit('loaded', { deviceNumber: args.deviceNumber, relays });
            }
        } catch (e) {
            commit('toggleRelay', args);
        }
    },
    unlock({ commit }) {
        commit('unlock');
        setTimeout(() => {
            commit('lock');
        }, 3 * 60 * 1000); // 3 minutes
    },
    async turnOn(
        { commit, state, rootState },
        args: { deviceNumber: string, relayNumber: number, turnOfAfterMs?: number}) {

        commit('turnOn', { deviceNumber: args.deviceNumber, relayNumber: args.relayNumber });
        commit('setLoading', args);
        try {
            const api = ApiProvider.getDeviceApi();
            await api.setRelay(new SetRelayRequest({
                deviceId: args.deviceNumber,
                relayNumber: args.relayNumber,
                turnOn: true,
                turnOfAfterMs: args.turnOfAfterMs,
            }));
            commit('setLoading', {
                deviceNumber: args.deviceNumber,
                relayNumber: args.relayNumber,
                loading: false,
            });
            if (args.turnOfAfterMs) {
                setTimeout(() => {
                    commit('turnOff', { deviceNumber: args.deviceNumber, relayNumber: args.relayNumber });
                }, 1000);
            }

        } catch (e) {
            commit('turnOff', { deviceNumber: args.deviceNumber, relayNumber: args.relayNumber });
        }
    },
    async holdOn(
        { commit, state, rootState },
        args: { deviceNumber: string, relayNumber: number}) {
        hold = true;
        commit('turnOn', { deviceNumber: args.deviceNumber, relayNumber: args.relayNumber });
        commit('setLoading', args);
        const api = ApiProvider.getDeviceApi();

        const call = async () => {
            try {
                await api.setRelay(new SetRelayRequest({
                    deviceId: args.deviceNumber,
                    relayNumber: args.relayNumber,
                    turnOn: true,
                    turnOfAfterMs: 2500,
                }));
                commit('setLoading', {
                    deviceNumber: args.deviceNumber,
                    relayNumber: args.relayNumber,
                    loading: false,
                });
                if (hold) {
                    holdTimeout = setTimeout(call, 500);
                }
            } catch {
                if (hold) {
                    holdTimeout = setTimeout(call, 500);
                }
            }
        };
        call();
    },
    async holdOff(
        { commit, state, rootState },
        args: { deviceNumber: string, relayNumber: number}) {
        clearTimeout(holdTimeout);
        hold = false;
        commit('turnOff', { deviceNumber: args.deviceNumber, relayNumber: args.relayNumber });
        commit('setLoading', args);
        const api = ApiProvider.getDeviceApi();

        await api.setRelay(new SetRelayRequest({
            deviceId: args.deviceNumber,
            relayNumber: args.relayNumber,
            turnOn: false,
        }));
        commit('setLoading', {
            deviceNumber: args.deviceNumber,
            relayNumber: args.relayNumber,
            loading: false,
        });

    },
};
